import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from './Box';
import { mergeClasses } from '@/utils/style';
export const TableCol = t0 => {
  const $ = _c(8);
  const {
    className,
    children,
    isActive,
    variant
  } = t0;
  const t1 = variant === "text" && "text-right font-semibold lg:text-center";
  const t2 = variant === "header" && "text-xl font-semibold text-blue-500 lg:text-center";
  const t3 = isActive && "block";
  let t4;
  if ($[0] !== className || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = mergeClasses("hidden lg:block lg:w-full lg:flex-shrink-1", t1, t2, t3, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <p className={t4}>{children}</p>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const TableRow = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = mergeClasses("flex flex-row items-center justify-between gap-6");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const ProductTable = () => {
  const $ = _c(59);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pricing"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("products.table.1");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TableCol isActive={true}>{t1}</TableCol>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("products.payInThree.1");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TableCol variant="text" isActive={true} className="text-right!">{t3}</TableCol>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <TableRow>{t2}{t4}</TableRow>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("products.table.4");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <TableCol isActive={true}>{t6}</TableCol>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <br />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = <TableCol variant="text" isActive={true} className="text-right!"><Trans t={t} i18nKey="products.payInThree.4">{t8}</Trans></TableCol>;
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <TableRow>{t7}{t9}</TableRow>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("products.table.5");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <TableCol isActive={true}>{t11}</TableCol>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("products.payInThree.5");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13) {
    t14 = <TableCol variant="text" isActive={true} className="text-right!">{t13}</TableCol>;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t12 || $[31] !== t14) {
    t15 = <TableRow>{t12}{t14}</TableRow>;
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("products.table.2");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <TableCol isActive={true}>{t16}</TableCol>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <br />;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = <TableCol variant="text" isActive={true} className="text-right!"><Trans t={t} i18nKey="products.payInThree.2">{t18}</Trans></TableCol>;
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t17 || $[41] !== t19) {
    t20 = <TableRow>{t17}{t19}</TableRow>;
    $[40] = t17;
    $[41] = t19;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t("products.table.3");
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t21) {
    t22 = <TableCol isActive={true}>{t21}</TableCol>;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <br />;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t) {
    t24 = <TableCol variant="text" isActive={true} className="text-right!"><Trans t={t} i18nKey="products.payInThree.3">{t23}</Trans></TableCol>;
    $[48] = t;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t22 || $[51] !== t24) {
    t25 = <TableRow>{t22}{t24}</TableRow>;
    $[50] = t22;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t10 || $[54] !== t15 || $[55] !== t20 || $[56] !== t25 || $[57] !== t5) {
    t26 = <Box><div className="flex flex-col gap-4">{t5}{t10}{t15}{t20}{t25}</div></Box>;
    $[53] = t10;
    $[54] = t15;
    $[55] = t20;
    $[56] = t25;
    $[57] = t5;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  return t26;
};